import { Coordinates, MosaicItem, Roi } from '../../entities';
import type { AnalyzerEntity } from '@telespot/domain';

export class MosaicMapper {
  public static createSpatialKey(roi: Coordinates & Pick<MosaicItem, 'findingId'>): string {
    return `${roi.findingId}_${Number(roi.x0)}_${Number(roi.y0)}_${Number(roi.x1)}_${Number(roi.y1)}`;
  }

  // TODO: test using similar tests as indexeddb mapper
  public static mosaicsToRois(items: MosaicItem[]): Roi[] {
    const rois: Map<string, Roi> = new Map();

    for (const item of items) {
      const roiId = this.createSpatialKey(item);

      const roi = {
        id: roiId,
        uuid: item.id,
        assetId: item.assetId,
        analysisId: item.analysisId,
        findingId: item.findingId,
        sampleId: item.sampleId,
        findingVersion: item.findingVersion,
        findingVersionId: item.findingVersionId,
        creatorId: item.creatorId,
        coordinates: {
          x0: Number(item.x0),
          y0: Number(item.y0),
          x1: Number(item.x1),
          y1: Number(item.y1),
        },
        labels: new Map([[item.label, item.score]]),
        cropFile: item.cropFile,
        additionalLabelsIncluded: false,
        pipelineStepId: item.stepId,
        pipelineId: item.pipelineId,
        findingType: item.type,
        creatorEntity: item.creatorEntity as AnalyzerEntity,
      };

      const existingRoi = rois.get(roiId);

      if (!existingRoi || existingRoi.findingVersion < item.findingVersion) {
        rois.set(roiId, roi);
        continue;
      }

      if (existingRoi.findingVersion > item.findingVersion) continue;

      existingRoi.labels.set(item.label, item.score);
    }

    return Array.from(rois.values());
  }
}
